import { Component, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'smart-edit-schedual',
  templateUrl: './edit-schedual.component.html',
  styleUrls: [
    './edit-schedual.component.scss',
    '../../platform-color/platform-color.css'
  ]
})
export class EditScheduleComponent implements OnInit, OnDestroy {
  @Output() Edit = new EventEmitter();
  showEdit = false;
  formSchedual: FormGroup;
  result: any
  error = false;
  Schedual = false;
  Condition = false;
  type: any = [];
  lengthForm: any;
  farmId: any;
  plotId: any;
  sensorId: any;
  thingsByid: any;
  thingId: any;
  sensor: any;
  things: any;

  thingAll: any;
  sensorByThing: any;
  sensorByThingOther: any;
  schId: any;
  arrSchbyId: any;
  DayChecked: any;
  checkShow = false;
  editConditionTwo = false;
  parseCon: any = [];
  opeChecked: any = [];
  checkBetween = false;
  textControl: any;
  arrDataSensor: any;
  mode: any;
  checkOtherBetween = false;
  opeCheckedOther: any;
  start_time: any;
  Hours: any = [];
  Minutes: any = [];
  isSubmitted = true;


  txtSw: string;
  txtSwCondition: string = "ปิด";
  txtSwConditionOther: string = "ปิด";

  isTabLoading: boolean = false;
  autoSyncFlag: boolean = false;
  alertErrorSchAndCon: boolean = false;
  onlineConfigs = [];
  constructor(
    private farm: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private farmService: FarmService,
  ) {

    this.formSchedual = this.farm.group({
      schedual_type: new FormControl(null, [Validators.required]),
      schedual_time_start: this.farm.array([]),
      schedual_work: new FormControl(null, [Validators.required]),
      schedual_time: new FormControl(null, [Validators.required]),
      schedual_time_unit: new FormControl(null, [Validators.required]),
      sensor_id: '',
      thing_id: '',
      condition: '',
      target1: '',
      target2: '',
      switch_main: '',
      time: '',
      time_unit: '',
      other_sensor_id: '',
      other_thing_id: '',
      other_condition: '',
      other_target1: '',
      other_target2: '',
      other_switch_main: '',
      other_time: '',
      other_time_unit: '',
      operation: '',

    });

    for (let index = 0; index < 24; index++) {
      let dataHour = index.toString();
      if (dataHour.length == 1) {
        dataHour = "0" + dataHour;
      }

      this.Hours.push(dataHour);
    }

    for (let index = 0; index < 60; index++) {
      let dataMinute = index.toString();
      if (dataMinute.length == 1) {
        dataMinute = "0" + dataMinute;
      }

      this.Minutes.push(dataMinute);
    }
  }
  reload(){
    this.isTabLoading = false;
    this.ngOnInit();
    setTimeout(() => {
      this.isTabLoading = true;
    }, 200);
  }

  ngOnInit(): void {
    window.scroll(0, 0);

    this.farmId = this.route.snapshot.queryParams["farmId"];
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.sensorId = this.route.snapshot.queryParams["sensorId"];
    this.thingId = this.route.snapshot.queryParams["thingId"];
    setTimeout(async () => {
      this.spinner.show();
      this.Edit.emit(true);
      await this.getThings(this.thingId, this.sensorId);
      await this.getScheduleById();
    }, 200);
  }

  ngOnDestroy() {
    $('#setControllabel2').modal('hide');
  }

  async getScheduleById() {
    setTimeout(async () => {
      this.schId = $('#edit_id').val();
      this.start_time = $('#start_time').val();
      let id = $('#id_row').val();
      let data = {
        thing_id: this.thingId,
        plot_id: this.plotId,
        sensor_id: this.sensorId,
        _id: id,
        sch_start_time: this.start_time == "" ? null : this.start_time
      }

      this.farmService.getSchedulebyId(data).subscribe(async success => {

        if (success.code == 200) {
          this.spinner.show();
          setTimeout(async () => {
            this.checkShow = true;
            this.arrSchbyId = success.data[0];

            if (this.arrSchbyId.sch_flag == "ALL") {
              this.Schedual = true;
              this.Condition = true;
            } else if (this.arrSchbyId.sch_flag == "SCH") {
              this.Schedual = true;
              this.Condition = false;

            } else if (this.arrSchbyId.sch_flag == "CON") {

              this.arrSchbyId.sch_start_time[0] = null
              this.Schedual = false;
              this.Condition = true;
            }


            this.selectType(this.convertDaytoNo(this.arrSchbyId.sch_type));
            this.checkedTypeDay(this.arrSchbyId.sch_date, this.convertDaytoNo(this.arrSchbyId.sch_type));

            for (let index = 0; index < this.arrSchbyId.sch_start_time.length; index++) {
              const element = this.arrSchbyId.sch_start_time[index];
              if (element != null) {
                const checkTimeStart = <FormArray>this.formSchedual.get('schedual_time_start') as FormArray;

                checkTimeStart.push(this.farm.group({
                  schedual_hours: element.split(".")[0],
                  schedual_minutes: element.split(".")[1]
                }))
              } else {
                const checkTimeStart = <FormArray>this.formSchedual.get('schedual_time_start') as FormArray;
                checkTimeStart.push(this.farm.group({
                  schedual_hours: "",
                  schedual_minutes: ""
                }))
              }
            }

            this.formSchedual.controls["schedual_time"].setValue(
              this.arrSchbyId.sch_time
            );
      
            if (this.arrSchbyId.sensor_action == 'ON') {
              this.txtSw = "เปิด"
              this.formSchedual.controls["schedual_work"].setValue(
                true
              );
            } else {
              this.txtSw = "ปิด"
              this.formSchedual.controls["schedual_work"].setValue(
                false
              );
            }

            if (this.arrSchbyId.condition != null) {
              this.parseCon = JSON.parse(this.arrSchbyId.condition);
              
              await this.selectThings('main', this.parseCon[0].thing_id);
              let sensorval = this.parseCon[0].sensor_id + "," + this.parseCon[0].sensor_name;
              let thingval = this.parseCon[0].thing_id + "," + this.parseCon[0].thing_name;
              if (this.parseCon[0].sensor_action == 'ON') {
                this.txtSwCondition = "เปิด"
                this.formSchedual.controls["switch_main"].setValue(
                  true
                );
              } else {
                this.txtSwCondition = "ปิด"
                this.formSchedual.controls["switch_main"].setValue(
                  false
                );
              }
              this.formSchedual.controls["sensor_id"].setValue(
                sensorval
              );

              this.formSchedual.controls["thing_id"].setValue(
                thingval
              );

              this.formSchedual.controls["time"].setValue(
                this.parseCon[0].sch_time
              );



              this.checkedOperation(this.convertOperationtoString(this.parseCon[0].operation, 'no'), 'main');

              if (this.parseCon[0].operation == "BETWEEN") {
                this.checkBetween = true;
                this.formSchedual.controls["target1"].setValue(
                  this.parseCon[0].Value1
                );

                this.formSchedual.controls["target2"].setValue(
                  this.parseCon[0].Value2
                );
              } else {
                this.checkBetween = false;
                this.formSchedual.controls["target1"].setValue(
                  this.parseCon[0].Value1
                );
              }


              if (this.parseCon.length == 2) {
                if (this.parseCon[1].sensor_action == 'ON') {
                  this.txtSwConditionOther = "เปิด"
                  this.formSchedual.controls["other_switch_main"].setValue(
                    true
                  );
                } else {
                  this.txtSwConditionOther = "ปิด"
                  this.formSchedual.controls["other_switch_main"].setValue(
                    false
                  );
                }

                this.editConditionTwo = true;

                await this.selectThings('other', this.parseCon[1].thing_id);
                let sensorvalOther = this.parseCon[1].sensor_id + "," + this.parseCon[1].sensor_name;
                let thingvalOther = this.parseCon[1].thing_id + "," + this.parseCon[1].thing_name;

                this.formSchedual.controls["other_thing_id"].setValue(
                  thingvalOther
                );

                this.formSchedual.controls["other_sensor_id"].setValue(
                  sensorvalOther
                );
                if (this.parseCon[1] != undefined) {
                  this.checkedOperation(this.convertOperationtoString(this.parseCon[1].operation, 'no'), 'other');
                }


                if (this.parseCon[1].operation == "BETWEEN") {
                  this.checkOtherBetween = true;
                  this.formSchedual.controls["other_target1"].setValue(
                    this.parseCon[1].Value1
                  );

                  this.formSchedual.controls["other_target2"].setValue(
                    this.parseCon[1].Value2
                  );
                } else {
                  this.checkOtherBetween = false;
                  this.formSchedual.controls["other_target1"].setValue(
                    this.parseCon[1].Value1
                  );
                }

                this.formSchedual.controls["other_time"].setValue(
                  this.parseCon[1].sch_time
                );

              }
            }
            this.spinner.hide();
          }, 200);
        }
      });
    }, 300);
  }

  addForm() {

    for (let index = 0; index < 1; index++) {

      const checkTimeStart = <FormArray>this.formSchedual.get('schedual_time_start') as FormArray;
      checkTimeStart.push(this.farm.group({
        schedual_hours: '',
        schedual_minutes: ''
      }))
    }
  }

  async getThings(id, sensor) {
    this.spinner.show();
    this.farmService.getThingById(this.farmId, this.plotId).subscribe(async success => {
      if (success.code == 200) {
        this.thingsByid = success.data || [];
   
        var foundThing = this.thingsByid.find(function (element) {
          return element.thing_id == id;
        });

        var foundSensor = foundThing.control.find(function (elementT) {
          return elementT.sensor_id == sensor;
        });
        this.sensor = foundSensor;
        this.things = foundThing;

        if (this.sensor.auto_sync_flag) {
          this.autoSyncFlag = true;
        }
        this.spinner.hide();

      }else{
        this.thingsByid = [];
        this.spinner.hide();
      }
    });
  }

  selectThings(type, id) {

    this.spinner.show();

    setTimeout(async () => {
      if (type == "main") {
        let split = id.split(",");
        this.farmService.getThingById(this.farmId, this.plotId).subscribe(async success => {
          if (success.code == 200) {
            var foundThing = success.data.find(function (element) {
              return element.thing_id == split[0];
            });

            this.sensorByThing = foundThing.sensor;

            this.spinner.hide();
          }
        });

      } else {
        let split = id.split(",");
        this.farmService.getThingById(this.farmId, this.plotId).subscribe(async success => {
          if (success.code == 200) {
            var foundThing = success.data.find(function (element) {
              return element.thing_id == split[0];
            });

            this.sensorByThingOther = foundThing.sensor;

            this.spinner.hide();
          }
        });
      } 
    }, 500);
  }


  convertDaytoNo(data) {

    let day = [];

    day["Daily"] = "Daily";
    day["Weekly"] = "7";
    day["Monthly"] = "12";


    return day[data];
  }

  convertStringDay(data) {

    let weekval = [];

    weekval["MON"] = 1;
    weekval["TUE"] = 2;
    weekval["WED"] = 3;
    weekval["THU"] = 4;
    weekval["FRI"] = 5;
    weekval["SAT"] = 6;
    weekval["SUN"] = 7;


    return weekval[data]
  }

  convertStringMonth(data) {
    let monthval = [];

    monthval["JAN"] = 1;
    monthval["FEB"] = 2;
    monthval["MAR"] = 3;
    monthval["ARP"] = 4;
    monthval["MAY"] = 5;
    monthval["JUN"] = 6;
    monthval["JUL"] = 7;
    monthval["AUG"] = 8;
    monthval["SEP"] = 9;
    monthval["OCT"] = 10;
    monthval["NOV"] = 11;
    monthval["DEC"] = 12;


    return monthval[data]
  }

  convertOperationtoString(data, type) {

    let operationSet = [];

    if (type == "text") {
      operationSet[">"] = "มากกว่า";
      operationSet["<"] = "น้อยกว่า";
      operationSet["="] = "เท่ากับ";
      operationSet["<>"] = "ไม่เท่ากับ";
      operationSet["BETWEEN"] = "ระหว่าง";
    } else if (type == "no") {
      operationSet[">"] = "1";
      operationSet["<"] = "2";
      operationSet["="] = "3";
      operationSet["<>"] = "4";
      operationSet["BETWEEN"] = "5";
    }


    return operationSet[data]

  }



  checkedOperation(data, type) {
    let opeChecked = [];
    for (let index = 0; index < 5; index++) {
      const element = index + 1;

      if (data == element) {
        opeChecked[element] = "checked";
      }

    }


    if (type == "main") {
      this.opeChecked = opeChecked;
    } else {
      this.opeCheckedOther = opeChecked;
    }


    // return opeChecked
  }

  checkedTypeDay(data, no) {

    let dataChecked = [];

    let splitDate = data.split(",");


    for (let index = 0; index < no; index++) {
      const element = index + 1;

      for (let indexs = 0; indexs < splitDate.length; indexs++) {
        if (no == 7) {
          var elements = this.convertStringDay(splitDate[indexs]);
        } else if (no == 12) {
          var elements = this.convertStringMonth(splitDate[indexs]);
        }

        if (element == elements) {

          dataChecked[splitDate[indexs]] = "checked";
        }

      }
    }

    // for
    this.DayChecked = dataChecked;

  }

  onSelectcrate(type, event) {

    let checkedschedual = $('#edit_schedual_chx').prop("checked");
    let checkedcondition = $('#edit_condition_chx').prop("checked");
    let customSwitchSCH = $('#edit_customSwitchSCH').prop("checked");

    let edit_other_switch_main = $('#edit_other_switch_main').prop("checked");
    let edit_customSwitch2 = $('#edit_customSwitch2').prop("checked");

    // alert(checkedschedual);
    if (type == 'Schedule-Head') {
      if (event == true) {
   
        this.Schedual = true;
      } else {

        // $('#edit_schedual_type').val("");
        // $('#hours').val("");
        // $('#minutes').val("");
        // $('#edit_customSwitchSCH').val("");
        // $('#edit_schedual_time').val("");
        // $('#edit_schedual_time_unit').val("");

        this.Schedual = false;
        // this.formSchedual.value.schedual_type = "";
        // this.formSchedual.value.schedual_hours = "";
        // this.formSchedual.value.schedual_minutes = "";
        // this.formSchedual.value.schedual_work = "";
        // this.formSchedual.value.schedual_time = "";
        // this.formSchedual.value.schedual_time_unit = "";
      }
    }


    if (type == 'Condition-Head') {
      if (event == true) {
        this.Condition = true;
      } else {
        this.Condition = false;
        this.editConditionTwo = false;
      }

    }

    if (customSwitchSCH == true) {
      this.txtSw = "เปิด";
    } else {
      this.txtSw = "ปิด";
    }

    if (edit_customSwitch2) {
      this.txtSwCondition = "เปิด"
    } else {
      this.txtSwCondition = "ปิด"
    }

    if (edit_other_switch_main) {
      this.txtSwConditionOther = "เปิด"
    } else {
      this.txtSwConditionOther = "ปิด"
    }
  }


  selectType(value) {

    this.type = [];
    let week = [];
    let weekval = [];
    let month = [];
    let monthval = [];
    // "Monthly"
    week[1] = "วันอาทิตย์";
    week[2] = "วันจันทร์";
    week[3] = "วันอังคาร";
    week[4] = "วันพุธ";
    week[5] = "วันพฤหัสบดี";
    week[6] = "วันศุกร์";
    week[7] = "วันเสาร์";

    weekval[1] = "SUN";
    weekval[2] = "MON";
    weekval[3] = "TUE";
    weekval[4] = "WED";
    weekval[5] = "THU";
    weekval[6] = "FRI";
    weekval[7] = "SAT";

    month[1] = "มกราคม";
    month[2] = "กุมภาพันธ์";
    month[3] = "มีนาคม";
    month[4] = "เมษายน";
    month[5] = "พฤษภาคม";
    month[6] = "มิถุนายน";
    month[7] = "กรกฎาคม";
    month[8] = "สิงหาคม";
    month[9] = "กันยายน";
    month[10] = "ตุลาคม";
    month[11] = "พฤศจิกายน";
    month[12] = "ธันวาคม";

    monthval[1] = "JAN";
    monthval[2] = "FEB";
    monthval[3] = "MAR";
    monthval[4] = "ARP";
    monthval[5] = "MAY";
    monthval[6] = "JUN";
    monthval[7] = "JUL";
    monthval[8] = "AUG";
    monthval[9] = "SEP";
    monthval[10] = "OCT";
    monthval[11] = "NOV";
    monthval[12] = "DEC";

    if (value != "Daily") {
      if (value == "7") {
        for (let index = 1; index <= value; index++) {
          const element = index;
          this.type.push({
            data: week[element],
            val: weekval[element]
          });

        }
      } else {
        for (let index = 1; index <= value; index++) {
          const element = index;
          this.type.push({
            data: month[element],
            val: monthval[element]
          });

        }
      }
    }
    // if (value != "Daily") {
    //   if (value == "7") {
    //     for (let index = 1; index <= value; index++) {
    //       const element = index;
    //       this.type.push({
    //         data: week[element],
    //         val: weekval[element]
    //       });

    //     }
    //   } else {
    //     for (let index = 1; index <= value; index++) {
    //       const element = index;
    //       this.type.push({
    //         data: element,
    //         val: element <= 9 ? "0" + element : element,
    //       });

    //     }
    //   }
    // }
  }




  addCondition() {
    // $('#edit_pnCondition').removeClass('dis-none');
    this.editConditionTwo = true;
  }
  removeCondition() {
    // $('#edit_pnCondition').removeClass('dis-none');
    this.editConditionTwo = false;
    $('#edit_operation').val("");
    $('#edit_other_thing_id').val("");
    $('#edit_example-operation').val("");
    $('#edit_other_condition').val("");
    $('#edit_other_target1_main').val("");
    $('#edit_other_switch_main').val("");
    // $('#condition_and_or').val("");
    // $('#other_thing_id').val("");
    // $('#other_condition_sensor').val("");
    // $('#other_condition').val("");
    // $('#condition_and_or_val').val("");
    // $('#condition_and_or_val_start').val("");
    // $('#condition_and_or_val_end').val("");
    // // $('#other_switch_main').val("");
    // $('#condition_and_or_time_input').val("");
    // $('#condition_and_or_time').val("");
    this.formSchedual.value.operation = "";
    this.formSchedual.value.other_thing_id = "";
    this.formSchedual.value.other_sensor_id = "";
    this.formSchedual.value.other_condition = "";
    this.formSchedual.value.other_target1 = "";
    this.formSchedual.value.other_target2 = "";
    this.formSchedual.value.other_switch_main = "";
    this.formSchedual.value.other_time = "";
    this.formSchedual.value.other_time_unit = "";
  }

  selectOperation(type, event) {
    if (type == "CH") {
      if (event == "5") {
        this.checkBetween = true;
      } else {
        this.checkBetween = false;
      }

    } else {
      if (event == "5") {
        this.checkOtherBetween = true;
      } else {
        this.checkOtherBetween = false;
      }
    }
  }

  // issue#80
  chkSubmitUpdateFarm() {
    this.isSubmitted = true;
    let sch_dmy = $('#edit_schedual_type').val();
    let hours = $('#hour').val();
    let minutes = $('#minute').val();
    let schedule_time_input = $('#edit_schedual_time').val();
    let schedule_time = $('#edit_schedual_time_unit').val();
    let checkedschedual = $('#edit_schedual_chx').prop("checked");
    let checkedcondition = $('#edit_condition_chx').prop("checked");

    let thing_id = $('#edit_thing_id').val();
    let condition_sensor = $('#edit_sensor_id').val();
    let condition_con = $('#edit_condition').val();
    let condition_val = $('#edit_target1_main').val();
    let condition_val_start = $('#edit_target1').val();
    let condition_val_end = $('#edit_target2').val();
    let condition_time_input = $('#edit_time').val();
    let condition_time = $('#edit_time_unit').val();

    let condition_and_or = $('#edit_operation').val();

    let other_thing_id = $('#edit_other_thing_id').val();
    let other_condition_sensor = $('#edit_example-operation').val();
    let other_condition = $('#edit_other_condition').val();
    let condition_and_or_val = $('#edit_other_target1_main').val();
    let condition_and_or_val_start = $('#edit_other_target1').val();
    let condition_and_or_val_end = $('#edit_other_target2').val();
    let condition_and_or_time_input = $('#edit_other_time').val();
    let condition_and_or_time = $('#edit_other_time_unit').val();

    // if ( this.arrSchbyId.sch_flag == "ALL") {
    //   this.Schedual = true;
    //   this.Condition = true;
    // } else if (this.arrSchbyId.sch_flag == "SCH") {
    //   this.Schedual = true;
    //   this.Condition = false;

    // } else if (this.arrSchbyId.sch_flag == "CON") {
    //   this.Schedual = false;
    //   this.Condition = true;
    // }



    if (checkedschedual == false && checkedcondition == false && this.arrSchbyId.sch_flag != "SCH" && this.arrSchbyId.sch_flag != "CON" && this.arrSchbyId.sch_flag != "ALL") {
      this.isSubmitted = false;

    }

    if (checkedschedual == true || this.arrSchbyId.sch_flag == "SCH" || this.arrSchbyId.sch_flag == "ALL") {

      if (sch_dmy == '' || hours == '' || minutes == '' || schedule_time_input == '' || schedule_time == '') {
        this.isSubmitted = false;
      } else if (sch_dmy && sch_dmy !== 'Daily') {

        let count = 0
        for (let i = 0; i < this.type.length; i++) {
          let type = $('#edit_type' + i).prop('checked')
          if (type == false) {
            count++
          }
        }
        if (count == this.type.length) {
          this.isSubmitted = false;
        }
      } else {
        this.isSubmitted = true;
      }
    }


    if (checkedcondition == true || this.arrSchbyId.sch_flag == "CON" || this.arrSchbyId.sch_flag == "ALL") {

      if (thing_id == '' || condition_sensor == '' || condition_con == '' || condition_time_input == '' || condition_time == '') {
        this.isSubmitted = false;

      } else if (condition_con == '5') {
        if (condition_val_start == '' || condition_val_end == '') {
          this.isSubmitted = false;
        }
      } else {
        if (condition_val == '') {
          this.isSubmitted = false;
        }
      }
   
      if (condition_and_or != '' && condition_and_or != null && condition_and_or != undefined) {

        if (other_thing_id == '' || other_condition_sensor == '' || other_condition == '' || condition_and_or_time_input == '' || condition_and_or_time == '') {
          this.isSubmitted = false;
        } else if (other_condition == '5') {
          if (condition_and_or_val_start == '' || condition_and_or_val_end == '') {
            this.isSubmitted = false;
          }
        } else {
          if (condition_and_or_val == '') {
            this.isSubmitted = false;
          }
        }
      }

    }


  }


  updateFarm() {
    this.chkSubmitUpdateFarm();

    if (this.isSubmitted == true) {
      this.alertErrorSchAndCon = false;

      let typeArr = [];
      let schedules = [];
      let operations = [];
      let mergCondition = [];

      operations["1"] = ">";
      operations["2"] = "<";
      operations["3"] = "=";
      operations["4"] = "<>";
      operations["5"] = "BETWEEN";

      $("input:checkbox[name=edit_type]:checked").each(function () {
        typeArr.push($(this).val());
      });


      let checkedschedual = $('#edit_schedual_chx').prop("checked");
      let checkedcondition = $('#edit_condition_chx').prop("checked");
      let edit_other_switch_main = $('#edit_other_switch_main').prop("checked");
      let edit_customSwitch2 = $('#edit_customSwitch2').prop("checked");

      if (checkedschedual == true && checkedcondition == false) {
        var sch_flag = "SCH";
      } else if (checkedschedual == false && checkedcondition == true) {
        var sch_flag = "CON";
      } else if (checkedschedual == true && checkedcondition == true) {
        var sch_flag = "ALL";
      }

      let splitThing = this.formSchedual.value.thing_id.split(",");
      let splitSensor = this.formSchedual.value.sensor_id.split(",");


     

      if (this.formSchedual.value.schedual_type == null) {
        this.formSchedual.value.schedual_type = this.arrSchbyId.sch_type;
      }

      if (this.formSchedual.value.schedual_time_unit == null) {
        this.formSchedual.value.schedual_time_unit = this.arrSchbyId.sch_unit_time;
      }

      // if (this.formSchedual.value.operation == "") {
      //   this.formSchedual.value.operation = this.arrSchbyId.operation;
      // }

      if (this.formSchedual.value.schedual_work == null) {
        this.formSchedual.value.schedual_work = this.arrSchbyId.sensor_action == "ON" ? true : false;
      }




      if (this.arrSchbyId.condition != null) {
        if (this.formSchedual.value.time_unit == "") {
          this.formSchedual.value.time_unit = this.parseCon[0].sch_unit_time;
        }
        if (this.formSchedual.value.condition == "") {
          this.formSchedual.value.condition = this.convertOperationtoString(this.parseCon[0].operation, 'no');
        }



        this.formSchedual.value.switch_main = edit_customSwitch2;


        if (this.parseCon[1] != undefined) {
          if (this.formSchedual.value.other_time_unit == "") {
            this.formSchedual.value.other_time_unit = this.parseCon[1].sch_unit_time;
          }

          if (this.formSchedual.value.other_condition == "") {
            this.formSchedual.value.other_condition = this.convertOperationtoString(this.parseCon[1].operation, 'no');
          }


          this.formSchedual.value.other_switch_main = edit_other_switch_main

        }
      }

      let Condition = {
        thing_id: splitThing[0],
        thing_name: splitThing[1],
        sensor_id: splitSensor[0],
        sensor_name: splitSensor[1],
        operation: operations[this.formSchedual.value.condition],
        Value1: this.formSchedual.value.target1,
        Value2: this.formSchedual.value.target2 == "" ? null : this.formSchedual.value.target2,
        sch_time: this.formSchedual.value.time,
        sch_unit_time: this.formSchedual.value.time_unit,
        sensor_action: this.formSchedual.value.switch_main == true ? "ON" : "OFF",
      };

      let splitThing_other = this.formSchedual.value.other_thing_id.split(",");
      let splitSensor_other = this.formSchedual.value.other_sensor_id.split(",");

      if (this.formSchedual.value.operation != null &&  this.formSchedual.value.operation != "") {
        let ConditionTwo = {
          thing_id: splitThing_other[0],
          thing_name: splitThing_other[1],
          sensor_id: splitSensor_other[0],
          sensor_name: splitSensor_other[1],
          operation: operations[this.formSchedual.value.other_condition],
          Value1: this.formSchedual.value.other_target1,
          Value2: this.formSchedual.value.other_target2 == "" ? null : this.formSchedual.value.other_target2,
          sch_time: this.formSchedual.value.other_time,
          sch_unit_time: this.formSchedual.value.other_time_unit,
          sensor_action: this.formSchedual.value.other_switch_main == true ? "ON" : "OFF",
        };
        mergCondition.push(Condition, ConditionTwo)
      } else {
        mergCondition.push(Condition)
      }

      let jsonData = JSON.stringify(mergCondition);

      if (this.formSchedual.value.schedual_type == "7") {
        this.formSchedual.value.schedual_type = "Weekly";
      } else if (this.formSchedual.value.schedual_type == "12") {
        this.formSchedual.value.schedual_type = "Monthly";
      } else {
        this.formSchedual.value.schedual_type = this.formSchedual.value.schedual_type;
      }


      this.schId = $('#edit_id').val();
      let rowId = $('#id_row').val();
      let data = {}
      if (this.formSchedual.value.schedual_time_start.length > 0 && checkedschedual == true) {
        this.formSchedual.value.schedual_time_start.forEach(element => {

          if (checkedschedual && checkedcondition) {
            data = {
              sch_name: "",
              sch_type: this.formSchedual.value.schedual_type == "" ? null : this.formSchedual.value.schedual_type,
              sch_date: typeArr.join(",") == "" ? "" : typeArr.join(","),
              sch_time: this.formSchedual.value.schedual_time == "" ? null : this.formSchedual.value.schedual_time,
              sch_unit_time: this.formSchedual.value.schedual_time_unit == "" ? null : this.formSchedual.value.schedual_time_unit,
              sch_start_time: element.time_start == "" ? null : this.convertTime(element.schedual_hours, element.schedual_minutes),
              sch_stop_time: element.time_start == "" ? null : this.convertTime(element.schedual_hours, element.schedual_minutes),
              thing_id: this.thingId,
              sensor_id: this.sensorId,
              condition: this.formSchedual.value.sensor_id == "" ? null : jsonData,
              operation: this.formSchedual.value.operation == "" ? null : this.formSchedual.value.operation,
              sensor_action: this.formSchedual.value.schedual_work == true ? "ON" : "OFF",
              sch_flag: sch_flag,
              sch_status: this.arrSchbyId.sch_status,
              plot_id: this.plotId,
              sch_id: this.schId,
              _id: rowId
            }
          } else {
            data = {
              sch_name: "",
              sch_type: this.formSchedual.value.schedual_type == "" ? null : this.formSchedual.value.schedual_type,
              sch_date: typeArr.join(",") == "" ? "" : typeArr.join(","),
              sch_time: this.formSchedual.value.schedual_time == "" ? null : this.formSchedual.value.schedual_time,
              sch_unit_time: this.formSchedual.value.schedual_time_unit == "" ? null : this.formSchedual.value.schedual_time_unit,
              sch_start_time: element.time_start == "" ? null : this.convertTime(element.schedual_hours, element.schedual_minutes),
              sch_stop_time: element.time_start == "" ? null : this.convertTime(element.schedual_hours, element.schedual_minutes),
              thing_id: this.thingId,
              sensor_id: this.sensorId,
              condition: null,
              operation: null,
              sensor_action: this.formSchedual.value.schedual_work == true ? "ON" : "OFF",
              sch_flag: sch_flag,
              sch_status: this.arrSchbyId.sch_status,
              plot_id: this.plotId,
              sch_id: this.schId,
              _id: rowId
            }

          }

          schedules.push(data)

        });

      } else if (checkedcondition == true && checkedschedual == false) {
  
        schedules.push({
          sch_name: "",
          sch_type: null,
          sch_date: "",
          sch_start_time: null,
          sch_time: null,
          sch_unit_time: null,
          sch_stop_time: null,
          thing_id: this.thingId,
          sensor_id: this.sensorId,
          condition: this.formSchedual.value.sensor_id == "" ? null : jsonData,
          operation: this.formSchedual.value.operation == "" ? null : this.formSchedual.value.operation,
          sensor_action: this.formSchedual.value.schedual_work == true ? "ON" : "OFF",
          sch_flag: sch_flag,
          sch_status: this.arrSchbyId.sch_status,
          plot_id: this.plotId,
          sch_id: this.schId,
          _id: rowId
        })
      }
      this.updateSchedule(schedules);
    } else {
      this.alertErrorSchAndCon = true;
    }
  }

  updateSchedule(schedules) {
     this.farmService.getUpdateSchedulebyId(schedules).subscribe(async success => {
        if (success.code == 200) {
          $('#editSchedual').modal('hide');
          Swal.fire({
            icon: 'success',
            title: 'ดำเนินการเสร็จสิ้น',
            showConfirmButton: false,
            timer: 1500
          }).then(res=>{
            window.location.reload();
          })
        } else {
          $('#editSchedual').modal('hide');
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาดในการสร้าง กรุณาลองใหม่อีกครั้ง',
            showConfirmButton: false,
            onClose: () => {
              window.location.reload();
            },
            timer: 1500
          })
        }
      });
  }

  calTime(data, time, unit) {

    
    let splData = data.split(".");
    let splitH = splData[0].split("0");
    let splitM = splData[1].split("0");

    if (splitH[0] == "") {
      var Hour = splitH[1];
    } else {
      var Hour = splData[0];
    }

    if (splitM[0] == "") {
      var Min = splitM[1];
    } else {
      var Min = splData[1];
    }




    var m = moment(new Date(0, 0, 0, Hour, Min, 0));
    if (unit == "seconds") {
      var m1 = moment(m).add(time, 's');
    }

    if (unit == "minutes") {
      var m1 = moment(m).add(time, 'm');
    }

    if (unit == "hours") {
      var m1 = moment(m).add(time, 'h');
    }


    return moment(m, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format("HH.mm.ss")
  }

  convertTime(hour, minutes) {
    var m = moment(new Date(0, 0, 0, hour, minutes, 0));

    return moment(m, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok').format("HH.mm.ss")
  }

  clossmodal() {
    $('#setControllabel2').modal('hide');
  }
  openControl() {

    if (this.sensor.sensor_type_status == 1) {
      $('#setControllabel2').modal('show');
    } else {
      this.updateFarm();
    }
  }

  clear() {
    $('#editSchedual').modal('hide');
    this.showEdit = false;
    setTimeout(async () => {
      $('#edit_id').val("");
      this.formSchedual.controls["schedual_time_start"].patchValue([]);
      this.Edit.emit(false);
    }, 10);
  }
}
